import { Component, Inject, Input } from '@angular/core';
import { Auth } from 'Src/ng2/shared/auth/auth.service';
import { ImUser } from '../../shared/services/im-models/im-user';
import { IUser } from '../../shared/typings/interfaces/user.interface';

export interface INavItem {
  key: string;
  humanName: string;
  stateName?: string;
}

@Component({
  selector: 'network-left-side-nav',
  template: require('./network-left-side-nav.component.html'),
  styles: [require('./network-left-side-nav.component.scss')],
})
export class NetworkLeftSideNavComponent {
  public selectedView: 'School' | 'Network';
  public userMenuOptions: INavItem[];
  public v3NavStatesMenu: any;
  public showPillToggle: boolean;

  @Input() currentUser: IUser;

  constructor(
    @Inject('$state') public $state,
    @Inject('$window') public $window: any,
    private auth: Auth,
    private imUser: ImUser,
  ) {}

  ngOnInit() {
    this.selectedView = 'Network';

    this.userMenuOptions = [
      {
        key: 'reportIssues',
        humanName: 'Report Issues',
        stateName: null,
      },
      {
        key: 'privacyAndTerms',
        humanName: 'Privacy & Terms',
        stateName: 'privacy-and-terms',
      },
      {
        key: 'logOut',
        humanName: 'Log out',
        stateName: null,
      },
    ];
    if (this.imUser.canViewNetworkSettings(this.currentUser)) {
      this.userMenuOptions.unshift({
        key: 'networkSettings',
        humanName: 'Settings',
        stateName: null,
      });
    }
    this.showPillToggle = this.imUser.canSeePillToggle(this.currentUser);
  }

  onViewToggle(viewName: 'School' | 'Network'): void {
    this.selectedView = viewName;
    if (viewName === 'School') this.goToSchool();
    else this.goToNetwork();
  }

  getStateParams(): { schoolId: string } | null {
    const { schoolId } = this.$state.params;
    return schoolId ? { schoolId } : null;
  }

  goToSchool(): void {
    const params = this.getStateParams();
    if (params) this.$state.go('main.school.home', params);
    else this.$state.go('main.cluster', params);
  }

  goToNetwork(): void {
    const params = this.getStateParams();
    this.$state.go('main.network.dashboard', params);
  }

  logout() {
    const tableauLogoutUrl = 'https://tableau.newvisions.org/auth/logout';
    (<HTMLImageElement>document.getElementById('logout-frame')).src = tableauLogoutUrl;
    this.auth.logout();
  }

  public goToState(option: INavItem): void {
    switch (option.key) {
      case 'networkSettings':
        this.$state.go('main.networkSettings');
        break;
      case 'reportIssues':
        this.$window.FreshWidget.show();
        break;
      case 'privacyAndTerms':
        const url = this.$state.href(option.stateName);
        this.$window.open(url, '_blank');
        break;
      case 'logOut':
        this.logout();
        break;
      default:
        return null;
    }
  }
}
